
<template>
<div>
  <multiselect v-model="value" deselect-label="Can't remove this value"
  track-by="shipName" label="shipName"
  placeholder="Select one" :options="shipInventorylist" :searchable="false" :allow-empty="false"  @select="changeSelection($event)">
    <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.shipName }}</strong> is written in<strong>  {{ option.shipId }}</strong></template>
  </multiselect>

</div>
</template>

<script>
import Multiselect from "vue-multiselect";



export default {
  name: "SelectorShip",
  props: ["shipInventorylist"],
  components: { Multiselect },
  data() {
    return {
      value: null,
  options: [
    {shipId:4,shipName:"Fovolos11a"},
    {shipId:5,shipName:"Fovolos11a2"}
    ],
    };
  },
  methods: {
    changeSelection(event) {
 this.$emit("changedSelect", event);
    },
    limitText(count) {
      return `and ${count} other Vessels`;
    },
  
    alertme: function() {},
    setSelection: function(newValue) {
      this.value = newValue;
    },
    returnSelection: function() {
      return this.value;
    }
  }
};
</script>


<style src="vue-multiselect/dist/vue-multiselect.css"></style>

